import { CONSENT_NAMES } from "./consents";
import { DATE_SORTERS } from "./general";
import { VotingsListQuestion } from "./votingQuestions";
import { ApiVotingQuestion } from "./votingView";

export enum VOTING_STATUSES {
  ONGOING = "ongoing",
  PLANNED = "planned",
  FINISHED = "finished",
  DRAFT = "draft"
}

export enum PUBLICITY_TYPES {
  PUBLIC = "public",
  NON_PUBLIC = "nonPublic"
}

export type GetOrganizerVotingsParams = {
  per_page: number;
  page_number?: number;
  status?: VOTING_STATUSES;
  electorate_type?: string;
  public?: boolean;
  sort?: DATE_SORTERS;
};

export type VotingCreatorType = {
  pictureUrl?: string;
  name: string;
};

export type VotingListItem = {
  id: string;
  name?: string;
  startDate?: string;
  endDate?: string;
  votingCreator: VotingCreatorType;
  status?: VOTING_STATUSES;
  isPublic?: boolean;
  votersCount?: number;
  votesCount?: number;
  questionsCount?: number;
};

export type VotingRequestFeedback = { isSuccess: boolean; message?: string };

export type GetPublicVotingsParams = {
  per_page: number;
  page_number?: number;
  status?: VOTING_STATUSES[];
  sort?: DATE_SORTERS;
  exclude_own?: boolean;
};

export type QuestionPreview = {
  content: string;
  options: string[];
  more: number;
};

export type ApiVotingListItem = {
  id: string;
  title: string;
  status: VOTING_STATUSES;
  public: boolean;
  start_date: string; //ISO string
  end_date: string; //ISO string
  voters_count?: number;
  votes_count?: number;
  questions_count?: number;
  electorate_type?: string;
  requires_verification?: boolean;
  verified_identity_required?: boolean;
  min_assurance_level?: number;
  signup_open?: boolean;
  signup_closes_at?: string | null;
  question_preview?: QuestionPreview | null;

  user: {
    id?: string;
    email: string;
    is_organization?: boolean;
    [CONSENT_NAMES.APPLICATIONS_SERVICE]?: boolean;
    [CONSENT_NAMES.APPLICATIONS_SERVICE]?: boolean;
    avatar_url?: string | null;
    profile_ref?: string | null;
    first_name?: string | null;
    last_name?: string | null;
    organization_name?: string | null;
  };
};

export type ParticipationItem = {
  id: string;
  title: string;
  status: VOTING_STATUSES;
  public: boolean;
  electorate_type?: string;
  requires_verification?: boolean;
  start_date: string;
  end_date: string;
  voted: boolean;
  protocol_url?: string | null;
  voters_count?: number | null;
  votes_count?: number | null;
  questions_count?: number | null;
  question_preview?: QuestionPreview | null;
  organizer?: {
    name: string;
    avatar_url?: string | null;
    profile_ref?: string | null;
  } | null;
};

export type ApiVotingListType = {
  votings: (ApiVotingListItem | VotingDraftApiType)[];
  meta: {
    total_pages: number;
  };
};

export type VotingDraftApiType = Partial<Omit<ApiVotingListItem, "user" | "id">> &
  Pick<ApiVotingListItem, "id" | "user">;

export type ApiVotingDraftDetails = {
  voting: VotingDraftApiType & {
    questions?: ApiVotingQuestion[];
    privacy_policy_url?: string | null;
    terms_and_conditions_url?: string | null;
    emails?: { id: string; value: string }[] | null;
    voter_list_url?: string | null;
  };
};

export type VotingDraftDetails = Partial<Omit<VotingListItem, "id" | "votingCreator" | "status" | "type">> & {
  id: string;
  questions?: VotingsListQuestion[];
  privacyPolicyUrl?: string;
  termsAndConditionsUrl?: string;
  emails?: { id: string; value: string }[];
  votersListUrl?: string;
  isPublic?: boolean;
};
